import PropTypes from 'prop-types';
import Button from 'sd-ui/dist/commonjs/components/Button/Button';
import Icon from '../../icon';

export default function PanelPaginationControls({
  goToNext,
  goToPrev,
  hasNext,
  hasPrev,
}) {
  return (
    <span
      className="arrow-container u-display-inline-block"
    >
      <Button
        title="Navigate left"
        disabled={!hasPrev}
        onClick={goToPrev}
        className="button-anchor"
        id="left-panel-button"
      >
        <Icon.NavigateLeft />
      </Button>

      <Button
        title="Navigate right"
        disabled={!hasNext}
        onClick={goToNext}
        className="button-anchor"
        id="right-panel-button"
      >
        <Icon.NavigateRight />
      </Button>
    </span>
  );
}

PanelPaginationControls.propTypes = {
  goToNext: PropTypes.func.isRequired,
  goToPrev: PropTypes.func.isRequired,
  hasNext: PropTypes.bool.isRequired,
  hasPrev: PropTypes.bool.isRequired,
};
